module.exports = __webpack_public_path__ + "assets/img/media-music-layer-47-b9b596fd.png";